import { useState } from 'react';
import { UserService } from '../../../services/user/userService';

/*-------------------------------------------------------------------------------------------------------
* EN: Hook to manage incidence users fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de usuarios para incidencias.
-------------------------------------------------------------------------------------------------------*/

const useIncidenceUsers = (initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const filters = {
        limit: 200,
        filter_filters: { ...initialFilters }
    };

    const fetchData = async (f?: any) => {
        setIsLoading(true);
        const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
        let mappedData: any[] = [];
        try {
            const response = await (new UserService()).listUsersForSelect(newFilters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                mappedData = fetchedData.data?.map((data: any) => ({
                    value: data.id,
                    label: data.name + (data.lastName ? ` ${data.lastName}` : ''),
                }));
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching incidence users:', error);
        } finally {
            setIsLoading(false);
            return mappedData;
        }
    };

    const getList = (entity?: string) => {
        if (entity) return data.filter((state: any) => state.value !== entity);
        return data;
    };

    const getEntity = (id: string) => {
        return data.find((entity: any) => entity.id === id);
    }

    return {
        getIncidenceUsersList: getList,
        getIncidenceUser: getEntity,
        fetchIncidenceUsersData: fetchData,
        isLoadingIncidenceUsers: isLoading
    };
}

export default useIncidenceUsers;